<template>
  <router-view/>
</template>
<script>
export default {
  data () {
    return {
      
    }
  },
  watch: {
    $route () {
      document.documentElement.scrollTop = 0
    }
  }
}
</script>
<style>
html, body, #app{
  width: 100%;
  height: 100%;
  margin: 0;
}
.ant-select-dropdown,.ant-select-dropdown-empty,.ant-empty-small{
    opacity: 0 !important;
    color: transparent;
    background: transparent !important;
}
</style>
